<template>
  <div class="mc-modal-alert__alert-main-wrapper">
    <div class="vehicle-information-wrapper">
      <div class="vehicle-information-item-wrapper">
        <label class="label-title">{{ $t('liveView.modal.fleetCategory') }}</label>
        <p>{{ vehicleCategory }}</p>
      </div>
      <div class="vehicle-information-item-wrapper vgroup">
        <label class="label-title">{{ $t('global.field.vehicleGroup') }}</label>
        <McChipList
          class="alert-center__popup-vgroup"
          :data-me="`modal-alert-media-vgroup-${rawAlertId}`"
          :items="vgroupItems || []"
          itemTextField="name"
          variant="outline-secondary"
          :hideToggle="true"
          :maxVisible="3"
          :truncateTextLength="9"
        />
      </div>
      <div class="vehicle-information-item-wrapper">
        <label class="label-title">{{ $t('global.driver') }}</label>
        <p>{{ driver ?? '-' }}</p>
      </div>
    </div>
    <slot />
    <SectionMedia
      ref="sectionMediaRef"
      :dvhData="dvhData"
      :statusText="statusText"
      :deviceType="deviceType"
      :vehicleIdCam="vehicleIdCam"
      :imeiCam="imeiCam"
      :alertCode="alertCode"
      :checkIsDmsAdas="checkIsDmsAdas"
      :rawAlertCreatedOn="rawAlertCreatedOn"
      :rawAlertId="rawAlertId"
    />
  </div>
</template>
<script>
import SectionMedia from './SectionMedia.vue'
import McChipList from '@/components/McChipList'
import { Helper } from '@/mixin/helper'
export default {
  components: { SectionMedia, McChipList },
  mixins: [Helper],
  props: {
    vehicleCategory: {
      type: String,
      required: true,
    },
    vgroups: {
      type: Array,
      required: true,
    },
    driver: {
      type: String,
      required: true,
    },
    statusText: {
      type: String,
      required: true,
    },
    dvhData: {
      type: Array,
      required: true,
    },
    deviceType: {
      type: String,
      required: true,
    },
    vehicleIdCam: {
      required: true,
      type: Number,
    },
    imeiCam: {
      required: true,
      type: String,
    },
    alertCode: {
      type: Number,
      required: true,
    },
    rawAlertId: {
      type: Number,
      required: true,
    },
    rawAlertCreatedOn: {
      type: String,
      required: false,
      default: '',
    },
    checkIsDmsAdas: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    vgroupItems() {
      return this.getSortedVgroupItems(this.vgroups)
    },
  },
}
</script>
